export default __webpack_public_path__ + "static/ceo-f5d0bb39d69b69b9fad75dd3dacaf5b5.webp";